import * as React from 'react';

import { ComponentType } from '@components/WebView/utils';
import AdventCalendar from '@containers/AdventCalendar/loadable';
import { LoadableTryAndBuy } from '@containers/UniversalTryAndBuy/loadable';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const SpecialPageComponent: React.FC<{ component: any }> = ({ component }) => {
  const { type, data } = component;

  switch (type) {
    case ComponentType.AdventCalendar:
      return <AdventCalendar {...data} />;

    // The universal try and buy
    case ComponentType.TryAndBuy:
      return <LoadableTryAndBuy campaignId={data.campaignId} />;

    default:
      return null;
  }
};

export default SpecialPageComponent;
